import React from "react";
import { useNavigate } from "react-router-dom";
import { Fingerprint, Lock, ArrowRight } from "lucide-react";

const AadhaarPayDashboard = () => {
  const navigate = useNavigate();

  const cards = [

    // vimopay 
    {
      title: "AadhaarPay 1",
      description: "Collect payment via Aadhaar",
      icon: <Fingerprint className="w-6 h-6 text-blue-600" />,
      route: "/aadhaar-pay-2",
      accent: "bg-blue-500",
    },



    // vimopay VimoAEPS1
    {
      title: "AadhaarPay 2",
      description: "Collect payment via Aadhaar",
      icon: <Fingerprint className="w-6 h-6 text-emerald-600" />,
      route: "/aadhaar-pay-3",
      accent: "bg-emerald-500",
    },


    //Fingpay
    {
      title: "AadhaarPay 3",
      description: "Collect payment via Aadhaar",
      icon: <Fingerprint className="w-6 h-6 text-violet-600" />,
      route: "/aadhaar-pay",
      accent: "bg-violet-500",
      disabled: true,
    },
  ];

  return (
    <div className="bg-[#F5F7FB] px-4 py-10 min-h-screen font-sans">
      <div className="max-w-6xl mx-auto">

        {/* PAGE HEADER */}
        <div className="mb-10">
          <h1 className="text-3xl font-bold text-gray-900 tracking-tight">
            Aadhaar Pay
          </h1>
          <p className="text-gray-500 mt-2 text-sm">
            Select a service below to proceed with your Aadhaar Pay transaction.
          </p>
        </div>

        {/* GRID */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((card, i) => (
            <div
              key={i}
              onClick={() => !card.disabled && navigate(card.route)}
              className={`
                relative group bg-white rounded-2xl p-5 border border-gray-100 shadow-sm
                flex items-center gap-4 transition-all duration-300 h-full min-h-[100px]
                ${card.disabled
                  ? "opacity-60 cursor-not-allowed bg-gray-50"
                  : "cursor-pointer hover:shadow-lg hover:-translate-y-1 hover:border-gray-200"
                }
              `}
            >
              {/* LEFT COLOR STRIP */}
              <div
                className={`absolute left-0 top-0 h-full w-1.5 ${card.accent} rounded-l-2xl`}
              />

              {/* DISABLED BADGE */}
              {card.disabled && (
                <div className="absolute top-3 right-3 bg-red-50 text-red-600 text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded-full flex items-center gap-1">
                  <Lock className="w-3 h-3" />
                  Disabled
                </div>
              )}

              {/* ACTIVE ARROW */}
              {!card.disabled && (
                <div className="absolute top-4 right-4 text-gray-300 opacity-0 transform -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
                  <ArrowRight className="w-4 h-4" />
                </div>
              )}

              {/* ICON */}
              <div className="p-3 bg-gray-50 rounded-xl border border-gray-100 shrink-0">
                {card.icon}
              </div>

              {/* TEXT */}
              <div className="flex-1 min-w-0 pr-4">
                <h3 className="text-[16px] font-semibold text-gray-800 leading-tight truncate">
                  {card.title}
                </h3>
                <p className="text-sm text-gray-400 mt-1 truncate">
                  {card.disabled ? "Currently unavailable" : card.description}
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default AadhaarPayDashboard;
